@use "../../styles/breakpoint.module.scss" as *;

.fullbleed {
    composes: repeater from "../../styles/layout.module.scss";
    row-gap: var(--spacer-64);

    .text {
        grid-column: col-start 4 / col-end 9;

        @media ($below-tablet) {
            grid-column: col-start 2 / col-end 11;
        }

        @media ($below-mobile) {
            grid-column: content;
        }
    }

    .media {
        grid-column: 1 / -1;
    }
}

.split {
    margin-block: var(--spacer-40);
    display: grid;
    grid-column: content;
    grid-template-columns: 1fr min-content 1fr;
    column-gap: var(--spacer-32);
    justify-content: stretch;

    [role="separator"] {
        background: var(--red);
        height: 100%;
    }

    .text {
        display: flex;
        flex-direction: column;
        align-items: start;

        & > :last-child {
            margin-top: auto;
        }
    }

    .media img {
        aspect-ratio: var(--image-ar);
        object-fit: cover;
    }

    @media ($below-tablet) and ($above-mobile) {
        .media img {
            aspect-ratio: none;
            height: 100%;
            object-fit: cover;
        }
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        row-gap: var(--spacer-40);

        [role="separator"] {
            display: none;
        }
    }
}

.category {
    composes: fontB20 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-16);
}

.title {
    composes: fontHB104 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-24);
}

.subtitle {
    composes: fontSH40 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-40);
}
